import React, { useEffect } from "react";
import NavbarPortal from "../../Components/Navbar";
import FooterPortal from "../../Components/Footer";

import TujuanProgram from "../../Components/Tentang/tujuanprogram";

export default function TujuanProgramPage() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div className="font-signika">
      <NavbarPortal />
      <div className="">
        <TujuanProgram />
      </div>

      <FooterPortal />
    </div>
  );
}
